import { SeFeDateTime } from 'se-fe-date-time'

export function dateRange(start: string, end: string, zone: string = 'local'): SeFeDateTime {
  return (start && end) ? new SeFeDateTime(start, end, { zone }) : new SeFeDateTime(start || end, { zone })
}
